import { HOME_ROUTE, langData, resendEmailVerificationLink, useAppDispatch } from '@hypexone/uicore';
import React, { useState } from 'react';

import { useNavigate } from 'react-router-dom';
import { getEnvVariable } from '../../constants/brandConfig';
import { BRAND_NAME, domain } from '../../constants/Branding';

export const ResendVerificationEmail = () => {
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');
    const navigate = useNavigate(); // from react-router-dom
    const dispatch = useAppDispatch(); // from react-redux
    const handleResend = async () => {
        setMessage('');
       const data= await dispatch(
            resendEmailVerificationLink({
                emailId: email.trim(),
                languageData: langData,
            })
        );
        navigate('/login');
        return;
    };

    return (
        <div className="flex items-center bg-gradient-to-r from-blue2 via-blue1 to-blue3 justify-center min-h-[100vh] bg-gradiantStyle px-4">
            <div className="w-full max-w-md bg-black border border-gray-300 rounded-xl shadow-md p-6">
                <div className="flex items-center justify-center gap-3 mb-6">
                    <div className='cursor-pointer' onClick={()=> window.location.href = '/login'}>
                    <img
            src={getEnvVariable(domain, "logo")}
            alt={BRAND_NAME ?? "logo"}
            className={`md:my-2 lg:my-0 cursor-pointer ${getEnvVariable(domain, "logoClassName") || "h-[28px] md:h-[40px] lg:h-[53px]"}`}
            onClick={() => navigate(`${HOME_ROUTE}`)}
          />
                    </div>
                    <h2 className="text-2xl font-semibold text-white">
                        Resend Verification Email
                    </h2>
                </div>

                <div className="flex flex-col gap-3">
                    <label htmlFor="email" className="text-sm font-medium text-white">
                        Email Address
                    </label>
                    <input
                        id="email"
                        type="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        placeholder=""
                        className="px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 transition"
                    />
                </div>

                {error && <p className="text-sm text-red-600 mt-2">{error}</p>}
                {message && <p className="text-sm text-green-600 mt-2">{message}</p>}

                <button
                    onClick={handleResend}
                    className="mt-5 w-full py-2 bg-blue-700 text-white font-semibold rounded-lg  transition"
                >
                    Resend Verification Link
                </button>
            </div>
        </div>
    );
};
export default ResendVerificationEmail;
